module.exports = __webpack_public_path__ + "static/cipDefault.08c19f0b.png";